<div fxLayout="row grow" class="ocr-control">
  <input #imgFileInput hidden type="file" name="file" (change)="fileChange($event)" placeholder="Upload file" accept=".jpg,.png">
  <mat-form-field fxFlex="100" appearance="outline" color="primary">
    <mat-label>Resultado</mat-label>
    <textarea #copyInput matInput placeholder="Resultado" readonly="readonly" matTextareaAutosize matAutosizeMinRows="1" [formControl]="ocrCtrl">{{ocrText}}</textarea>
  </mat-form-field>
  <div fxFlex></div>
  <button mat-button (click)="imgFileInput.click()">Procesar Imagen OCR</button>
  <button class="copy-button" mat-button [ngxClipboard]="copyInput" (cbOnSuccess)="isCopied = true" [class.copied]="isCopied">
    <mat-icon>file_copy</mat-icon>
    {{isCopied ? '¡Copiado!' : 'Copiar'}}
  </button>
</div>
